import * as React from 'react';

import Utils, { Validation, InputError, ReferralStatus } from '../../common/utils';

import { TextInput } from '../../components/forms';
import { Button } from '../../components/buttons';
import { Spinner } from '../../components/common';

interface Props {
	referrals: CustomerReferralResponse;
	currentUser: UserDetails;
	onSpousalInvite: (spousalName: string, spousalEmail: string, resetForm: Function) => void;
	disabled: boolean;
	isSubmittingSpousal: boolean;
	fullFormWidth?: boolean;
}
interface State {
	spousalName: string;
	spousalEmail: string;
	touched: {
		spousalEmail: boolean;
	};
}
class SpouseReferral extends React.Component<Props, State> {
	errors = { spousalEmail: {} as InputError };
	state = {
		spousalName: this.props.referrals.referredSpouseName ? this.props.referrals.referredSpouseName : '',
		spousalEmail: this.props.referrals.referredSpouseEmail ? this.props.referrals.referredSpouseEmail : '',
		touched: {
			spousalEmail: false
		}
	};

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}
	validate = () => {
		// true means invalid
		return {
			spousalEmail: Validation.validateEmail(this.state.spousalEmail)
		};
	}
	isSpousalInviteDisabled = () => {
		return !this.state.spousalName ||
		!this.state.spousalEmail ||
		this.errors.spousalEmail.hasError ||
		this.state.spousalEmail === this.props.currentUser.email!;
	}
	resetForm = () => {
		this.setState({spousalName: '', spousalEmail: '', touched: {spousalEmail: false}} );
	}
	
	renderReferralForm = () => {
		return (
			<div>
				<div className="text-center">
					<p>
						<strong>
							Refer your life partner and you each get up to $120 credit!
						</strong>
					</p>
					<p>
						Your code is: <strong>{this.props.referrals.spousalReferralCode || '-'}</strong>
					</p>
				</div>
				<div className="row">
					<TextInput
						labelText="Name"
						name="spousalName"
						placeholder="John Smith"
						value={this.state.spousalName}
						onChange={(e: any) => this.setState({ spousalName: e.target.value })}
						className={this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0 ml-md-auto'}
					/>
					<TextInput
						labelText="Email"
						name="spousalEmail"
						placeholder="john@example.com"
						value={this.state.spousalEmail}
						onBlur={this.handleBlur('spousalEmail')}
						onChange={(e: any) => this.setState({ spousalEmail: e.target.value })}
						className={this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0'}
						error={Utils.shouldMarkError(this.errors.spousalEmail, this.state.touched.spousalEmail) ?
									this.errors.spousalEmail : undefined}
					/>
					<div className={this.props.fullFormWidth ? 'col-12' : 'col-md-auto align-self-end mr-md-auto'}>
						<Button 
							className="btn-primary" 
							onClick={() => this.props.onSpousalInvite(this.state.spousalName, this.state.spousalEmail, this.resetForm)} 
							disabled={this.props.disabled || this.isSpousalInviteDisabled()}
						>
							Send Invite
							{this.props.isSubmittingSpousal && <Spinner />}
						</Button>
					</div>
				</div>
			</div>
		);
	}
	renderReferralComplete = () => {
		if (this.props.referrals.statusId === ReferralStatus.PolicyCancelled) {
			return (
				<p className="mb-0 text-center">
					Your life partner has cancelled the policy.
				</p>
			);
		} else if (this.props.referrals.statusId === ReferralStatus.ReferralApproved) {
			return (
				<p className="mb-0 text-center">
					Your life partner referral credit has been claimed.  You and your life partner each received a $120 credit.
				</p>
			);
		} else {
			return (
				<p className="mb-0 text-center">
					Your life partner referral credit has been claimed. You and your life partner 
					will each receive a $120 credit 31 days after the referred person signed up.
				</p>
			);
		}

	}

	public render() {
		this.errors = this.validate();
		return (
			<div className="border px-3 py-4 p-lg-4 d-flex flex-column justify-content-center w-100">
				{
					!this.props.referrals.isSpousalReferralUsed ? this.renderReferralForm() : this.renderReferralComplete()
				}
			</div>
		);
	}
}
export default SpouseReferral;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/referral/SpouseReferral.tsx